import fragment from './v3.main'

export default fragment
